import React, { useState, Fragment } from "react";
import { Link } from "react-router-dom";
import ContentLoader from "react-content-loader";
// css
import "./sofas.css";
import { ToastContainer, toast } from "react-toastify";
// Redux
import { connect } from "react-redux";
import PropTypes from "prop-types";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import StarRatings from "react-star-ratings";
import { randomProducts } from "../../actions/products";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

const IconComponent = () => {
  const [addToWish, setAddToWish] = useState(false);
  const callAddToWish = (quickView) => {
    setAddToWish(!addToWish);
  };

  return (
    <div
      onClick={() => {
        callAddToWish();
      }}
      className="heart-icon"
    >
      <i className={addToWish ? "far fa-heart iconBold" : "far fa-heart"} />
    </div>
  );
};

const options = {
  loop: true,
  margin: 10,
  nav: true,
  // autoplaySpeed: true,
  // autoplay: true,
  autoplayTimeout: 5000,
  autoplayHoverPause: true,
  animateOut: true,
  responsive: {
    0: {
      items: 1,
    },
    400: {
      items: 1,
    },
    600: {
      items: 2,
    },
    768: {
      items: 3,
    },
    1079: {
      items: 4,
    },
    1253: {
      items: 5,
    },
  },
};

const elements = ["1", "2", "3", "4", "5"];
class Sofas extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      products: [],
      loading: true,
      quickView: [],
      addToWish: false,
      itemTitle: "",
    };
  }
  async componentDidMount() {
    const productsArr = await this.props.randomProducts();
    // const productsArr = [];
    // products &&
    //   products.data.forEach(async (__element) => {
    //     __element &&
    //       Array.isArray(__element.category) &&
    //       __element.category.forEach((element) => {
    //         if ("5e7334991cdd330017cf61b7" === element) {
    //           productsArr.push(__element);
    //         }
    //       });
    //   });
    await this.setState({ products: productsArr });
    setTimeout(() => {
      this.setState({ loading: false });
    }, 3000);
  }
  productsLoader = (number) => {
    let table = [];

    for (let i = 0; i < number; i++) {
      table.push(
        <Fragment>
          {
            <ContentLoader
              speed={1}
              width={300}
              height={470}
              viewBox="0 0 300 470"
              backgroundColor="#f3f3f3"
              foregroundColor="#ecebeb"
            >
              <rect x="4" y="0" rx="0" ry="0" width="291" height="291" />
              <rect x="49" y="297" rx="0" ry="0" width="193" height="36" />
              <rect x="12" y="339" rx="0" ry="0" width="276" height="30" />
              <rect x="12" y="375" rx="0" ry="0" width="182" height="27" />
              <rect x="11" y="407" rx="0" ry="0" width="285" height="28" />
              <rect x="11" y="441" rx="0" ry="0" width="142" height="29" />
              <circle cx="273" cy="453" r="14" />
            </ContentLoader>
          }
        </Fragment>
      );
    }
    return table;
  };
  render() {
    const { quickView, products, loading } = this.state;
    return (
      <Fragment>
        <div className="explore-our-sals wrapper-90 max-1600">
          <div>
            <div className="my-3 ">
              <div>
                <div className="endless-heading mb-md-2 text-center py-2">
                  <h3>Products</h3>
                </div>
                {products && products.length > 0 ? (
                  <Fragment>
                    <OwlCarousel
                      className="homeProductSlider owl-theme"
                      {...options}
                    >
                      {this.state.products &&
                        this.state.products.map((item, index) =>
                          item.mainImage ? (
                            <div
                              className="item px-1 d-md-block h-100"
                              style={{ border: "1px solid #dadada" }}
                              key={index}
                            >
                              <IconComponent />

                              <Link
                                className="d-block"
                                to={`/product/${item.slug}`}
                              >
                                <div className="card-slide-img pt-0">
                                  <div
                                    style={{
                                      height: "250px",
                                      padding: "5px 0",
                                    }}
                                  >
                                    <div
                                      style={{
                                        backgroundImage: `url(${
                                          item.mainImage && item.mainImage
                                        })`,
                                        backgroundSize: "contain",
                                        height: "100%",
                                        backgroundRepeat: "no-repeat",
                                        backgroundPosition: "center",
                                      }}
                                    ></div>
                                  </div>

                                  {/* <img
                                  src={item.images && item.images[0]}
                                  height="280px"
                                  alt=""
                                /> */}
                                </div>
                                <div
                                  className="px-2 card-slide-content text-center"
                                  style={{
                                    backgroundColor: "#fff",
                                    borderRadius: "10px",
                                  }}
                                >
                                  <div className="only-at-sundial">
                                    <p className="text-center">
                                      Only at Sundial
                                    </p>
                                  </div>
                                  {item.brands && item.brands.length !== 0 ? (
                                    <span className="  text-center">
                                      <LazyLoadImage
                                        effect="blur"
                                        src={item.brands[0].storeLogo}
                                        width="160px"
                                        alt=""
                                        style={{ padding: "0px 25px" }}
                                      />
                                    </span>
                                  ) : (
                                    <LazyLoadImage
                                      effect="blur"
                                      src="https://sundialinsider.s3.us-east-2.amazonaws.com/54logo.png"
                                      width="150px"
                                      alt=""
                                    />
                                  )}

                                  <ul className="text-left card-star-list">
                                    <StarRatings
                                      rating={
                                        item && item.reviews
                                          ? item.reviews / item.reviewCount
                                          : 0
                                      }
                                      starDimension="20px"
                                      starSpacing="2px"
                                      starRatedColor="gold"
                                    />
                                    <span>{item && item.reviewCount}</span>
                                  </ul>
                                  <p>
                                    {item.title && item.title.length < 25
                                      ? item.title
                                      : item.title.substring(0, 24)}
                                  </p>

                                  <div className="slide-view-link">
                                    <Link to={`/product/${item.slug}`}>
                                      View Product
                                      <i className="fa fa-arrow-right" />
                                    </Link>
                                  </div>
                                </div>
                              </Link>
                            </div>
                          ) : null
                        )}
                    </OwlCarousel>
                  </Fragment>
                ) : (
                  <Fragment>
                    {loading === true ? (
                      <Fragment>
                        <div className="fiveScreen-owlCarousel">
                          {this.productsLoader(5)}
                        </div>
                        <div
                          className="fourScreen-owlCarousel"
                          style={{ display: "none" }}
                        >
                          {this.productsLoader(4)}
                        </div>
                        <div
                          className="threeScreen-owlCarousel"
                          style={{ display: "none" }}
                        >
                          {this.productsLoader(3)}
                        </div>
                        <div
                          className="twoScreen-owlCarousel"
                          style={{ display: "none" }}
                        >
                          {this.productsLoader(2)}
                        </div>
                        <div
                          className="oneScreen-owlCarousel"
                          style={{ display: "none" }}
                        >
                          {this.productsLoader(1)}
                        </div>
                      </Fragment>
                    ) : null}
                  </Fragment>
                )}
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}
randomProducts.propTypes = {
  randomProducts: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  getProducts: state.getProducts,
});

export default connect(mapStateToProps, { randomProducts })(Sofas);
